module.exports = __webpack_public_path__ + "2265e3b6464b811966e5bb241a5c5a1d.pdf";